export enum BookingStep {
  ProductList = 'list',
  ProposalSelect = 'proposalSelect',
  ProposalMap = 'proposalMap',
  Cart = 'cart',
  Booking = 'booking'
}
